import { DateTime, Interval } from "luxon"

import ReportingData from "../../models/reportingData"
import { removeTimeFromISODateString } from "../../utils/date"

export interface AvailableReportDatesDto {
  end: string
  start: string
}

/**
 * Fetches a range of the available report dates for an organization
 * where 'start' is the beginning of the start month
 * and 'end' is the end of the end month
 *
 * @param orgId - The organization id
 * @returns The available report dates
 * @example
 * fetchAvailableReportDates("1")
 */
export const fetchAvailableReportDates = async (
  orgId: string
): Promise<Interval | null> => {
  try {
    const availableReportDates = await ReportingData.where({
      organization_id: orgId,
    })
      .stats({
        min_max_months: "calculate",
      })
      .all()
      .then((result) => {
        // migration to strict mode batch disable
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const dateRange: AvailableReportDatesDto =
          // Mass lint disable
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          result.meta.stats.min_max_months.calculate

        // Remove timezone from server dates so they can be compared to YYYY-MM-DD dates
        const start = DateTime.fromISO(
          removeTimeFromISODateString(dateRange.start)
        ).startOf("month")
        const end = DateTime.fromISO(
          removeTimeFromISODateString(dateRange.end)
        ).endOf("month")

        return Interval.fromDateTimes(start, end)
      })

    return availableReportDates
  } catch {
    // Request may fail if the organization has no usage data
    // Return null instead of throwing an error so UI can handle no data display
    return null
  }
}

export default {
  fetchAvailableReportDates,
}
